import axios from '@/common/axios'
import API from '@/config/apis'

// 请求banner图
export function getBanner(params) {

	return new Promise(function(resolve, reject){
		axios('post', API.PROFILE.BANNER,params)
			.then(function (result) {
				resolve(result.data)
			})
	})

}

// 请求研发与制造的内容
export function getAbout(params) {

	return new Promise(function(resolve, reject){
		axios('post', API.PROFILE.DETAIL,params)
			.then(function (result) {
				resolve(result.data)
			})
	})

}